let scrollPositionTop = window.scrollY;
let headerSticky = document.getElementsByClassName('site-header')[0];

window.addEventListener('scroll', function(){

    scrollPositionTop = window.scrollY;

    if(scrollPositionTop >= 30){
        headerSticky.classList.add('masthead-sticky');
    } else {
        headerSticky.classList.remove('masthead-sticky');
    }

})

